import React, { useState } from "react"
import { useToasts } from "react-toast-notifications"
import { addProductToRegistry } from "../../utils/ApiRequests"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import FullLoader from "../Loaders/FullLoader"

const DashboardItemPreview = ({ product, closeModal, inStock, addProduct }) => {
  const { _id: id, name, sales_price, images, sku: details } = product
  const [quantity, setQuantity] = useState(1)
  const [loading, setLoading] = useState(false)
  const [showCart, setShowCart] = useState(false)

  const { addToast } = useToasts()

  if (quantity < 1) {
    setQuantity(1)
  }

  if (quantity > inStock) {
    setQuantity(inStock)
  }

  return (
    <div
      style={{ width: "900px", maxWidth: "900px" }}
      className="bg-white shadow-md rounded pb-12 p-8 pt-2"
    >
      {loading && <FullLoader />}
      <button
        className="ml-auto -mb-4 block bg-white p-3 text-center text-red-400 rounded-md focus:outline-none"
        onClick={() => closeModal()}
      >
        <img src={require("../../assets/close.svg").default} alt="close" />
      </button>
      <div className="grid mobiles:block grid-cols-2 gap-8">
        <div>
          <div className="shadow-md">
            <img src={images[0]} alt="" className="w-full block" />
          </div>

          <div className="mt-6 grid gap-6 grid-cols-3">
            <img src={images[0]} alt="" className="w-full block" />
            <img src={images[1]} alt="" className="w-full block" />
            <img src={images[2]} alt="" className="w-full block" />
          </div>
        </div>

        <div className="pt-5">
          <p className="font-semibold">{`${name}`}</p>
          <p className="text-red-500 mt-2">₦{`${sales_price}`}</p>
          <p className="text-green-500 mt-2">In Stock</p>

          <div className="p-6 mt-4 border border-gray-200 rounded items-center flex-1 flex justify-between">
            <div className="w-24 px-1 flex justify-between border border-gray-200 items-center h-10">
              <span
                className="w-6 h-6 flex justify-center items-center text-xl text-white bg-gray-300 rounded-full cursor-pointer"
                onClick={() => setQuantity(quantity - 1)}
              >
                -
              </span>
              <p>{`${quantity}`}</p>
              <span
                className="w-6 h-6 flex justify-center items-center text-xl text-white bg-green-300 rounded-full cursor-pointer"
                onClick={() => setQuantity(quantity + 1)}
              >
                +
              </span>
            </div>
            <button
              // to="/sign-up"
              onClick={() => {
                addProduct([{ product: id, quantity: quantity }])
                closeModal()
              }}
              className=" py-2 px-2 mobiles:px-3 bg-sbg-purple border border-transparent text-transparent rounded-lg text-xs text-white "
            >
              Add to registry
            </button>
          </div>
          <div className="mt-5">
            <h4 className="font-semibold">Description</h4>
            <p className="mt-3 text-gray-600">{`${details}`}</p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default DashboardItemPreview
